import { Injectable } from '@angular/core';

@Injectable()
export class DBkeys {

  public static readonly CURRENT_USER = 'current_user';
  public static readonly ACCESS_TOKEN = 'access_token';
  public static readonly ID_TOKEN = 'id_token';
  public static readonly REFRESH_TOKEN = 'refresh_token';
  public static readonly TOKEN_EXPIRES_IN = 'expires_in';
  public static readonly REMEMBER_ME = 'remember_me';
  public static readonly CURRENT_ORG = 'current_org';
  public static readonly ALLOW_CHG = 'allow_change';
  public static readonly CURRENT_PERMISSIONS = 'current_permissions';
  public static readonly LOGOUT_MESSAGE_KEY = 'logout_message';
  public static readonly ENC_USER = 'enc_usr';
  public static readonly ENC_ORGID = 'enc_org';
  public static readonly ORG_CNT = 'org_cnt';
  public static readonly DARK_FEATURE = 'uploadsFeature';
}
